/**
 * Dashboard 細項 route 與各自的日期 query key（snake_case，送 API 用；也是 response `period` 與鑽取列表的 key）。
 * 主控台 overview 會把共通日期區間映射到每個 module 的成對 query；
 * `overviewDateFromParam`／`overviewDateToParam` 只在 overview query 名稱與細項不同時設定（非庫存採購）。
 */
export const DASHBOARD_MODULE_ROUTES = {
  salesOrder: {
    path: '/crm/sales-order/dashboard',
    dateFromParam: 'sales_order_date_from',
    dateToParam: 'sales_order_date_to',
  },
  customerOrder: {
    path: '/crm/customer-order/dashboard',
    dateFromParam: 'customer_order_date_from',
    dateToParam: 'customer_order_date_to',
  },
  purchaseOrder: {
    path: '/srm/purchase-order/dashboard',
    dateFromParam: 'purchase_order_date_from',
    dateToParam: 'purchase_order_date_to',
  },
  miscPurchaseOrder: {
    path: '/srm/misc-purchase-order/dashboard',
    dateFromParam: 'purchase_order_date_from',
    dateToParam: 'purchase_order_date_to',
    overviewDateFromParam: 'misc_purchase_order_date_from',
    overviewDateToParam: 'misc_purchase_order_date_to',
  },
  stockReceipt: {
    path: '/ims/stock-receipt/dashboard',
    dateFromParam: 'receipt_date_from',
    dateToParam: 'receipt_date_to',
  },
  stockIssue: {
    path: '/ims/stock-issue/dashboard',
    dateFromParam: 'issue_date_from',
    dateToParam: 'issue_date_to',
  },
  workOrder: {
    path: '/mom/work-order/dashboard',
    dateFromParam: 'scheduled_start_date_from',
    dateToParam: 'scheduled_start_date_to',
  },
};

/** overview 支援的 module（be doc 96c8fcd8 起含非庫存採購） */
export const DASHBOARD_OVERVIEW_MODULE_KEYS = [
  'salesOrder',
  'customerOrder',
  'purchaseOrder',
  'miscPurchaseOrder',
  'stockReceipt',
  'stockIssue',
  'workOrder',
];

/**
 * 日期區間 → 該 module 的成對 query；未選（null／缺一端）時不送，後端用 Asia/Taipei 當月。
 * @param {string} moduleKey
 * @param {{ from?: string, to?: string } | null | undefined} range
 */
export function toDashboardDateParams(moduleKey, range) {
  const route = DASHBOARD_MODULE_ROUTES[moduleKey];
  if (!route || !range?.from || !range?.to) {
    return {};
  }
  return {
    [route.dateFromParam]: range.from,
    [route.dateToParam]: range.to,
  };
}

/**
 * 日期區間 → overview 上該 module 的成對 query（非庫存採購用 `misc_purchase_order_date_*`）。
 * @param {string} moduleKey
 * @param {{ from?: string, to?: string } | null | undefined} range
 */
export function toDashboardOverviewDateParams(moduleKey, range) {
  const route = DASHBOARD_MODULE_ROUTES[moduleKey];
  if (!route || !range?.from || !range?.to) {
    return {};
  }
  return {
    [route.overviewDateFromParam ?? route.dateFromParam]: range.from,
    [route.overviewDateToParam ?? route.dateToParam]: range.to,
  };
}
